import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { RoutesConfig } from './routes';

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={RoutesConfig.Dashboard.fullPath} replace />;
  }

  return <>{children}</>;
}
